// Opening hours: {"mon": [["10:00","13:00"],["14:00","19:00"]], ...}. A slot closing before it opens runs past midnight.
export const DAYS = [
  ["mon", "Lundi"], ["tue", "Mardi"], ["wed", "Mercredi"], ["thu", "Jeudi"], ["fri", "Vendredi"], ["sat", "Samedi"], ["sun", "Dimanche"],
];
const KEYS = DAYS.map(([k]) => k);
const toMin = (hhmm) => { const [h, m] = hhmm.split(":").map(Number); return h * 60 + m; };

// Paris time (all LGTDZ places are in the same time zone)
const parisNow = (date = new Date()) => {
  const parts = Object.fromEntries(new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Paris", weekday: "short", hour: "2-digit", minute: "2-digit", hourCycle: "h23",
  }).formatToParts(date).map((p) => [p.type, p.value]));
  return { day: KEYS.indexOf(parts.weekday.toLowerCase().slice(0, 3)), min: Number(parts.hour) * 60 + Number(parts.minute) };
};

export const hasHours = (hours) => !!hours && Object.values(hours).some((s) => s?.length);

// true / false, or null when the place has no hours
export const isOpenNow = (hours, date) => {
  if (!hasHours(hours)) return null;
  const { day, min } = parisNow(date);
  const today = hours[KEYS[day]] || [];
  const yesterday = hours[KEYS[(day + 6) % 7]] || [];
  const inToday = today.some(([o, c]) => (toMin(c) > toMin(o) ? min >= toMin(o) && min < toMin(c) : min >= toMin(o)));
  const fromYesterday = yesterday.some(([o, c]) => toMin(c) <= toMin(o) && min < toMin(c));
  return inToday || fromYesterday;
};

export const todayKey = (date) => KEYS[parisNow(date).day];
export const formatSlots = (slots) => (slots?.length ? slots.map(([o, c]) => `${o.replace(":", "h")} – ${c.replace(":", "h")}`).join(" · ") : "Fermé");
